import React, { useState } from 'react';
import '../../Assets/Css/SetSlot.css';

const SetSlot = ({ onBack, onNext }) => {
  const [selectedSlot, setSelectedSlot] = useState('');

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot);
  };

  return (
    <div className="set-slot-wrapper">
      <h2 className="set-slot-heading">Set Slot</h2>
      <div className="set-slot-buttons">
      {["9 AM - 12 PM", "12 PM - 3 PM", "3 PM - 6 PM", "6 PM - 9 PM"].map(
          (slot) => (
            <button
              key={slot}
              className={`set-slot-button ${
                selectedSlot === slot ? "set-slot-selected" : ""
              }`}
              onClick={() => handleSlotClick(slot)}
            >
              {slot}
            </button>
          )
        )}
      </div>

      <div className="sset-slot-buttons">
        <button
          className="sset-slot-button sset-slot-back-button"
          onClick={onBack} // Navigate back to SetDate
        >
          Back
        </button>
        <button
          className="sset-slot-button sset-slot-next-button"
          onClick={() => onNext(selectedSlot)} // Pass selected slot
          disabled={!selectedSlot}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SetSlot;
